import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  ButtonDirective,
  DividerComponent,
  ModalComponent,
  ModalService,
  Option,
  RadioButtonDirective,
  RibbonDirective,
  SelectComponent,
  SkeletonLoaderDirective,
  StepDirective,
  TooltipDirective
} from '@com-delta-omnichannel/aura';
import { NotificationComponent } from '../notification/notification.component';
import { ReviewComponent } from '../review/review.component';
import { EnrollDetail, Options } from './models/options.interfaces';
import { OptionsExtendedComponent } from './options-extended.component';

@Component({
  selector: 'idp-options',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReviewComponent,
    ModalComponent,
    NotificationComponent,
    ReactiveFormsModule,
    StepDirective,
    DividerComponent,
    ButtonDirective,
    RadioButtonDirective,
    TooltipDirective,
    SkeletonLoaderDirective,
    RibbonDirective,
    SelectComponent
  ],
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss']
})
export class OptionsComponent
  extends OptionsExtendedComponent
  implements OnChanges, OnInit
{
  @Input() content: Options = {} as Options;
  @Output() closeError: EventEmitter<void> = new EventEmitter<void>();
  @Output() enroll: EventEmitter<EnrollDetail[]> = new EventEmitter<
    EnrollDetail[]
  >();

  @Output() selectedExtension: EventEmitter<Option> =
    new EventEmitter<Option>();

  @ViewChild('tooltip') tooltip!: ElementRef;
  @ViewChild('auraSelect') auraSelect!: SelectComponent;

  showModal = false;
  submitAttempt = false;
  confirm = false;
  dropdownOptions: Option[] = [];
  placeholderText = '';

  constructor(public modalService: ModalService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['content']?.currentValue.notification.success === false) {
      this.close();
    }
  }

  ngOnInit(): void {
    this.dropdownOptions = this.getDropDownItems(this.content.steps);
    this.placeholderText = this.getPlaceholderText(this.content.steps);
  }

  change(selectedOption: Option) {
    this.displayTooltip = false;
    this.selectedExtension.emit(selectedOption);
  }

  opened(value: boolean) {
    if (value) {
      this.modalService.overlayRef.updateSize({
        width: window.innerWidth > 768 ? '860px' : '90%'
      });
    }
  }

  close() {
    this.showModal = false;
    this.submitAttempt = false;
    this.confirm = false;
    this.modalService.overlayRef.dispose();
  }

  onSubmit(content: Options, tooltip: ElementRef) {
    this.submitAttempt = true;
    if (content.form.valid) {
      window.scrollTo(0, 0);
      content = this.updateSelections(content);
      this.showModal = true;
    } else {
      this.displayTooltip = true;
      this.scrollToError(content.form, this.auraSelect?.id || '');
      this.displayError(content, tooltip);
    }
  }

  onConfirm() {
    this.enroll.emit(this.getSelectedValue(this.content.form.getRawValue()));
    this.confirm = true;
  }

  displayError(content: Options, tooltip: ElementRef) {
    if (content.form.controls['extension']) {
      content.form.controls['extension'].markAsTouched();
      if (content.form.controls['extension'].valid) {
        tooltip.nativeElement.click();
      }
    } else {
      tooltip.nativeElement.click();
    }
  }
}
